import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-change-simb',
  templateUrl: './change-simb.component.html',
  styleUrls: ['./change-simb.component.scss']
})
export class ChangeSimbComponent implements OnInit {

  @Input('isVisible') isVisible: Boolean;
  @Output() closeModal = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  close(value: string): void {
    console.log("confirm change simb", value);
    let data = {
      isVisible: false,
      value: value
    }
    this.closeModal.emit(data);
  }

}
